var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCloseIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 9.401,
  height: 9.399,
  viewBox: "0 0 9.401 9.399"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "Icon_ionic-ios-close",
  "data-name": "Icon ionic-ios-close",
  d: "M17.1,15.988l3.358-3.358a.787.787,0,0,0-1.113-1.113l-3.358,3.358-3.358-3.358a.787.787,0,1,0-1.113,1.113l3.358,3.358-3.358,3.358a.787.787,0,0,0,1.113,1.113L15.987,17.1l3.358,3.358a.787.787,0,0,0,1.113-1.113Z",
  transform: "translate(-11.285 -11.289)",
  fill: "#7b7b7b"
})));
export { SvgCloseIcon as ReactComponent };
export default __webpack_public_path__ + "static/media/closeIcon.282816e33a7ad33faa4b6a916a8533d8.svg";